module.exports = __webpack_public_path__ + "img/testEwm.aaf029fb.png";